export default __webpack_public_path__ + "static/yoga-8-c06f3d811c65c4dbd33e737a180064aa.png";